import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

import Foot from "./components/foot.vue"
Vue.component("Foot",Foot)

import {
  get,
  post,
  json,
  download
} from "./util/js/http"
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$json = json;
Vue.prototype.$download = download;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
